export const CHANGE_SORT = 'change-sort';
const changeSort = ({ sort }) => ({ type: CHANGE_SORT, payload: { sort } });
export default changeSort;
